import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MoveCameraService } from '../Component(2D and 3D)/2D/move-camera.service';
import { CameraService } from './camera.service';
import { ViewSwitcherService } from './view-switcher.service';
import { ZoomService } from './zoom.service';
import { StairsDimensionService } from './stairs-dimension.service';
import { Select3dService } from './select-3d.service';
import { RootComponent } from './proTools/components/RootComponent';
import { ToolSwitcher } from './proTools/ToolSwitcher';
import { ImageUtilsService } from './image-utils.service';


@Injectable()
export class ProToolsUiManagerService {

  public loginViaAdmin: boolean = false;
  public proToolsMod: boolean = false;
  public proToolsModActive = new Subject<boolean>();
  private oldScale = { x: 1, y: 1 };
  private oldSelectedStair = null;
  public saved: boolean = false;

  constructor(
    private selectSrvc: Select3dService,
    private moveCameraService: MoveCameraService,
    private cameraService: CameraService,
    private viewSwitcher: ViewSwitcherService,
    private zoomService: ZoomService,
    private stairDimesionService: StairsDimensionService,
    private rootComponent: RootComponent,
    private toolSwitcher: ToolSwitcher,
    private imageUtils: ImageUtilsService
  ) { }

  proToolsSwitcher(step) {
    const cameraStatus = this.cameraService.isIn2D() && !this.proToolsMod;
    const camera = this.cameraService.getCamera();
    if (step === 1) {
      this.imageUtils.isShowDimensionsSubject.next(true);
      this.imageUtils.showSprites();
    } else {
      this.imageUtils.isShowDimensionsSubject.next(false);
      this.imageUtils.removeSprites();
    }
    if (step !== 3) {
      if (this.proToolsMod) {

        this.zoomService.setProToolsModConfig(false);
        this.zoomService.reset();
        this.proToolsMod = false;
        this.proToolsModActive.next(this.proToolsMod);
        this.viewSwitcher.switchView(this.proToolsMod);
        this.viewSwitcher.needViewModeIconUpdate.next(this.proToolsMod);
        if (this.oldSelectedStair) {
          this.stairDimesionService.update(this.oldSelectedStair);
        }
        camera.scale.set(this.oldScale.x, this.oldScale.y, 1);
      }
      this.moveCameraService.disable();
      if (cameraStatus) {
        this.moveCameraService.enable();
      }
    } else {
      if (this.cameraService.isIn3D()) {
        this.cameraService.switchTo2D();
      }
      this.zoomService.reset();
      this.proToolsMod = true;
      this.proToolsModActive.next(this.proToolsMod);
      this.viewSwitcher.switchView(this.proToolsMod);
      this.viewSwitcher.needViewModeIconUpdate.next(this.proToolsMod);
      // this.moveCameraService.disable();
      if (this.selectSrvc.getSelectedStair()) {
        this.oldSelectedStair = this.selectSrvc.getSelectedStair();
      }
      if (!this.stairDimesionService.isVisible()) {
        this.oldSelectedStair = null;
      }
      this.stairDimesionService.hide();
      this.zoomService.reset();
      this.zoomService.setProToolsModConfig(true);

      this.oldScale.x = camera.scale.x;
      this.oldScale.y = camera.scale.y;
      this.toolSwitcher.select();
    }
  }

  getIsProToolsMode(): boolean {
    return this.proToolsMod;
  }

  getIsSaved(): boolean {
    return this.saved;
  }

  save(value) {
    this.saved = value;
    this.rootComponent.saved = value;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pro-tools-ui-manager.service.ts